export default [
  // 系统素材
  {
    path: '/lcd/systemMaterial',
    name: 'system-material',
    component: () => import('@/views/lcd/material/systemMaterial'),
  },
  // 商户素材
  {
    path: '/lcd/merchantMaterial',
    name: 'merchant-material',
    component: () => import('@/views/lcd/material/merchantMaterial'),
  },
  // 素材审核
  {
    path: '/lcd/reviewMaterial',
    name: 'review-material',
    component: () => import('@/views/lcd/material/reviewMaterial'),
  },
  // 营销模板
  {
    path: '/lcd/popTemplate',
    name: 'pop-pemplate',
    component: () => import('@/views/lcd/template/pop'),
  },
  // // 编辑器
  // {
  //   path: '/lcd/editor',
  //   name: 'lcd-editor',
  //   component: () => import('@/views/lcd/template/editor'),
  // },
  // 设备列表
  {
    path: '/lcd/device',
    name: 'lcd-device',
    component: () => import('@/views/lcd/device/lcdList'),
  },
  // 营销投放
  {
    path: '/lcd/adSpace',
    name: 'ad-space',
    component: () => import('@/views/lcd/device/adSpace'),
  },
  // 设备日志
  {
    path: '/lcd/deviceLog',
    name: 'lcd-device-log',
    component: () => import('@/views/lcd/device/deviceLog'),
  },
]